import React, { useState, useEffect } from "react";
import { Box, CssBaseline, useMediaQuery, useTheme } from "@mui/material";
import { ToastContainer } from "react-toastify";
import { GlobalLoading } from "react-global-loading";
import { PulseLoader } from "react-spinners";

import LeftSidebar from "./LeftSidebar";
import TopNavbar from "./TopNavbar";
import ScrollToTop from "./ScrollToTop";

/**
 * MainLayout - Layout for authenticated pages
 * Includes sidebar and header
 */
export default function MainLayout({ user, children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    // On desktop, sidebar is always open
    if (!isMobile) {
      setSidebarOpen(true);
    }
  }, [isMobile]);

  const handleSidebarToggle = () => {
    // Only toggle on mobile
    if (isMobile) {
      setSidebarOpen(!sidebarOpen);
    }
  };

  return (
    <>
      <CssBaseline />
      <Box sx={{ display: "flex", minHeight: "100vh" }}>
        <ToastContainer
          position={isMobile ? "top-center" : "top-right"}
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />

        <LeftSidebar user={user} open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            marginLeft: isMobile ? 0 : "280px",
            transition: theme.transitions.create("margin", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
          }}
        >
          <ScrollToTop />
          <TopNavbar user={user} onMenuClick={handleSidebarToggle} />
          <Box sx={{ p: { xs: 2, sm: 3 }, flex: 1, overflowX: "hidden" }}>{children}</Box>
        </Box>

        <GlobalLoading zIndex={9999}>
          <PulseLoader color={"white"} size={30} />
        </GlobalLoading>
      </Box>
    </>
  );
}
